import { defineStore } from 'pinia'

import { createMaterialsActions } from './actions'
import { createMaterialsState } from './state'

export const useMaterialsStore = defineStore('materials', () => {
    const state = createMaterialsState()
    const actions = createMaterialsActions(state)

    return {
        ...state,
        ...actions
    }
})
